import { AnalyticBaseProperties } from './analytic-base-properties.model';
export class AnalyticPilotLogoutProperties extends AnalyticBaseProperties {
  constructor() {
    super();
  }

  override parse(): any {
    return super.parse();
  }
}
